export default __webpack_public_path__ + "4660658466013c3df4905f2b1e400f75.svg";